import PropTypes from 'prop-types';
import React, { Component } from 'react';

class Curtain extends Component {
  render() {
    const { children, isOpen } = this.props;
    return isOpen ? (
      <div>
        <div
          className="animated fadeIn"
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            background: 'rgba(0,0,0,0.85)',
            zIndex: 10,
            overflow: 'auto',
            opacity: 0,
          }}
        />
        <div
          className="d-flex fd-col align-center jc-center text-center"
          style={{
            color: '#fff',
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 20,
          }}
        >
          {children}
        </div>
      </div>
    ) : null;
  }
}

Curtain.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
};

export default Curtain;
